import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useRef } from 'react';
import styled from '../utils/styling/styled-components';
import { Position, isAlignmentVertical } from '../Position';
import { BasePopover, ARROW_WIDTH } from './BasePopover';
var AnchorWrapper = styled.div(_templateObject());
/**
 * Popover component. Can be used for both dropdowns and generic popover content.
 */

export var Popover = function Popover(_ref) {
  var _ref2, _anchorWrapperEl$curr, _anchorWrapperEl$curr2, _props$offset;

  var children = _ref.children,
      content = _ref.content,
      id = _ref.id,
      role = _ref.role,
      props = _objectWithoutProperties(_ref, ["children", "content", "id", "role"]);

  var anchorWrapperEl = useRef(null); // Automatically aligns arrow with center of anchor

  var size = (_ref2 = isAlignmentVertical(props.alignment) ? (_anchorWrapperEl$curr = anchorWrapperEl.current) === null || _anchorWrapperEl$curr === void 0 ? void 0 : _anchorWrapperEl$curr.clientWidth : (_anchorWrapperEl$curr2 = anchorWrapperEl.current) === null || _anchorWrapperEl$curr2 === void 0 ? void 0 : _anchorWrapperEl$curr2.clientHeight) !== null && _ref2 !== void 0 ? _ref2 : 20;
  var arrowOffset = size / 2 - (props.arrowSize || ARROW_WIDTH) - ((_props$offset = props.offset) !== null && _props$offset !== void 0 ? _props$offset : 0);
  return /*#__PURE__*/React.createElement(Position, _extends({
    content: /*#__PURE__*/React.createElement(BasePopover, {
      alignment: props.alignment,
      arrowColor: props.arrowColor,
      arrowOffset: arrowOffset,
      arrowSize: props.arrowSize,
      id: id,
      onClick: props.onClick,
      role: role
    }, content)
  }, props), /*#__PURE__*/React.createElement(AnchorWrapper, {
    ref: anchorWrapperEl
  }, children));
};
export { BasePopover };